/**
 * Constants for Tiled layer names, object types, property keys, and default values.
 * Used when parsing Entities and Paths object layers from a Tiled map.
 */

/** Canonical layer names expected in the Tiled map. */
export const LAYERS = {
  Ground: 'Ground',
  Walls: 'Walls',
  Entities: 'Entities',
  Paths: 'Paths',
} as const;

/** Object type names used within Tiled object layers. */
export const OBJECT_TYPES = {
  PlayerSpawn: 'PlayerSpawn',
  Powerup: 'Powerup',
  Consumable: 'Consumable',
  Enemy: 'Enemy',
  Path: 'Path',
} as const;

/** Property keys read from Tiled object properties for entities and paths. */
export const PROPS = {
  facing: 'facing',
  powerupType: 'powerupType',
  ammo: 'ammo',
  respawn: 'respawn',
  rotate: 'rotate',
  consumableType: 'consumableType',
  heal: 'heal',
  enemyType: 'enemyType',
  speed: 'speed',
  vision: 'vision',
  patrolPathId: 'patrolPathId',
  patrolLoop: 'patrolLoop',
  patrolWait: 'patrolWait',
  id: 'id',
  closed: 'closed',
} as const;

/**
 * Default gameplay values applied when specific properties are omitted in Tiled.
 * Enemy defaults are per-type and can be overridden via object properties.
 */
export const DEFAULTS = {
  pistolAmmo: 12,
  waterHeal: 25,
  enemy: {
    Grunt: { speed: 80, vision: 220 },
    Fast: { speed: 120, vision: 200 },
    Tank: { speed: 60, vision: 260 },
  },
} as const;